import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FavoritesStore"*/ './lazyIndex'),
    { name: 'FavoritesStore' }
);

export const lazyMoveFavoriteUpDown: LazyImport<
    typeof lazyIndex.moveFavoriteUpDown,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.moveFavoriteUpDown);
export const lazyUpdateFavoritePosition: LazyImport<
    typeof lazyIndex.updateFavoritePosition,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.updateFavoritePosition);
export const lazyAddFavoriteCategory: LazyImport<
    typeof lazyIndex.addFavoriteCategory,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteCategory);
export const lazyRemoveFavoriteCategory: LazyImport<
    typeof lazyIndex.removeFavoriteCategory,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteCategory);
export const lazyAddNewMailboxDefaultFavorites: LazyAction<
    typeof lazyIndex.addNewMailboxDefaultFavorites,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addNewMailboxDefaultFavorites);
export const lazyRemoveFavoritePersona: LazyImport<
    typeof lazyIndex.removeFavoritePersona,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoritePersona);
export const lazyAddFavoritePersona: LazyImport<
    typeof lazyIndex.addFavoritePersona,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoritePersona);

export const lazyRemoveFavoriteGroup: LazyImport<
    typeof lazyIndex.removeFavoriteGroup,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteGroup);
export const lazyAddFavoriteGroup: LazyImport<
    typeof lazyIndex.addFavoriteGroup,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteGroup);

export const lazyRemoveFavoriteFolder: LazyImport<
    typeof lazyIndex.removeFavoriteFolder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteFolder);
export const lazyAddFavoriteFolder: LazyImport<
    typeof lazyIndex.addFavoriteFolder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteFolder);

export const lazyRemoveFavoritePlaceholder: LazyImport<
    typeof lazyIndex.removeFavoritePlaceholder,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoritePlaceholder);

export const lazySetOutlookFavoritesBitFlag: LazyAction<
    typeof lazyIndex.setOutlookFavoritesBitFlag,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setOutlookFavoritesBitFlag);
// Favoriting actions
export const lazyAddFavoriteToStore: LazyImport<
    typeof lazyIndex.addFavoriteToStore,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteToStore);
export const lazyAddFavoriteCompleted: LazyImport<
    typeof lazyIndex.addFavoriteCompleted,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteCompleted);
export const lazyAddFavoriteFailed: LazyImport<
    typeof lazyIndex.addFavoriteFailed,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addFavoriteFailed);

export const lazyAddMultipleFavoritesCompleted: LazyImport<
    typeof lazyIndex.addMultipleFavoritesCompletedMutator,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.addMultipleFavoritesCompletedMutator);

export const lazyRemoveFavoriteFromStore: LazyImport<
    typeof lazyIndex.removeFavoriteFromStore,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteFromStore);
export const lazyRemoveFavoriteCompleted: LazyImport<
    typeof lazyIndex.removeFavoriteCompleted,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.removeFavoriteCompleted);
export const lazyRemoveFavoriteFailed: LazyAction<
    typeof lazyIndex.removeFavoriteFailed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeFavoriteFailed);
export const lazyEditOutlookFavoriteService: LazyAction<
    typeof lazyIndex.editOutlookFavoriteService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.editOutlookFavoriteService);
export const lazyCreateOutlookFavoriteService: LazyAction<
    typeof lazyIndex.createOutlookFavoriteService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createOutlookFavoriteService);
export const lazyDeleteOutlookFavoriteService: LazyAction<
    typeof lazyIndex.removeOutlookFavoriteHelper,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeOutlookFavoriteHelper);
export const lazyCreateMultipleOutlookFavoritesService: LazyAction<
    typeof lazyIndex.createMultipleOutlookFavoritesService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createMultipleOutlookFavoritesService);
export const lazyGetOutlookFavoritesService: LazyAction<
    typeof lazyIndex.getOutlookFavoritesService,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOutlookFavoritesService);
export const lazySubscribeToFavoriteNotifications: LazyAction<
    typeof lazyIndex.subscribeToFavoriteNotificationsForMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.subscribeToFavoriteNotificationsForMailbox);
